import { Box, Typography } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { useEffect } from "react";

interface Props {
  label: string;
  name: string;
  file?: File | null;
  existingFile?: string;
  onChange: (name: string, file: File | null) => void;
  error?: string;

  // 🔥 NEW
  disabled?: boolean;
}

const UploadCard = ({
  label,
  name,
  file,
  existingFile,
  onChange,
  error,

  // 🔥 NEW
  disabled = false,
}: Props) => {
  //const BASE_URL = process.env.REACT_APP_BASE_URL;
  const BASE_URL = "https://api.ssquarelogic.com/";
  //const BASE_URL = "http://localhost:3012";

  const previewUrl =
    file instanceof File
      ? URL.createObjectURL(file)
      : existingFile
      ? `${BASE_URL}/uploads/${existingFile}`
      : null;

  useEffect(() => {
    return () => {
      if (file instanceof File && previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [file, previewUrl]);

  return (
    <Box sx={{ flex: 1 }}>
      <Box
        component="label"
        sx={{
          height: 70,
          border: error
            ? "1px dashed red"
            : "1px dashed #d1d5db",

          borderRadius: "10px",
          background: "#f8fafc",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",

          // 🔥 UPDATED
          cursor: disabled ? "default" : "pointer",

          gap: 0.5,

          // 🔥 OPTIONAL
          opacity: disabled ? 0.8 : 1,
        }}
      >
        {previewUrl ? (
          <>
            <img
              src={previewUrl}
              style={{
                height: 40,
                objectFit: "cover",
              }}
            />

            <Typography sx={{ fontSize: 10 }}>
              {file?.name || existingFile}
            </Typography>
          </>
        ) : (
          <>
            <UploadFile sx={{ fontSize: 18 }} />

            <Typography sx={{ fontSize: 10 }}>
              {label}
            </Typography>
          </>
        )}

        {/* 🔥 FILE INPUT */}
        <input
          hidden
          disabled={disabled}
          type="file"
          onChange={(e) =>
            onChange(
              name,
              e.target.files?.[0] || null,
            )
          }
        />
      </Box>

      {error && (
        <Typography
          sx={{
            color: "red",
            fontSize: 10,
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default UploadCard;